export const COUPON_REDEMPTION_METHOD = {
  MERCHANT_APP_SCAN_COUPON_QR_CODE: 'MERCHANT_APP_SCAN_COUPON_QR_CODE',
  USERS_SCAN_STORE_QR_CODE: 'USERS_SCAN_STORE_QR_CODE',
  USERS_COPY_THE_DISCOUNT_CODE: 'USERS_COPY_THE_DISCOUNT_CODE',
  INPUT_STORE_STAFF_CODE: 'INPUT_STORE_STAFF_CODE',
  POS_UPDATED_CODE: 'POS_UPDATED_CODE',
};

export const COUPON_FORMATS = {
  COUPON_QR_CODE: 'COUPON_QR_CODE',
  COUPON_BAR_CODE: 'COUPON_BAR_CODE',
  TEXT: 'TEXT',
};

export const BARCODE_METHOD = {
  'EAN-13': 'EAN13',
  'UPC-A': 'upc',
  'Code 39': 'CODE39',
  'Code 128': 'CODE128',
};

export const COUPON_TEMPLATE_TYPE = {
  IMPORT_EXISTING_COUPON: 'IMPORT_EXISTING_COUPON',
  SYSTEM_GENERATED: 'SYSTEM_GENERATED',
};

export const ProfileEditType = {
  FirstName: 1,
  LastName: 2,
  Gender: 3,
  Birthday: 4,
  LoginAndContact: 5,
  Email: 6,
  PhoneNumber: 7,
  contactForDirectMarketing: 8,
};

export const ProfileEditState = {
  Normal: 1,
  Editing: 2,
  Disable: 3,
};

export const GenderType = {
  Female: 'FEMALE',
  Male: 'MALE',
  NotDisclosed: 'NOT_DISCLOSED',
};

export const CUSTOMER_SIGN_UP_METHOD = {
  MOBILE_PHONE_NUMBER: 'MOBILE_PHONE_NUMBER',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS:
    'MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS',
  'GOOGLE-OAUTH2': 'GOOGLE-OAUTH2',
  FACEBOOK: 'FACEBOOK',
  'APPLE-ID': 'APPLE-ID',
};

export const SupportedCountryCodeList = ['852', '853', '86'];

export const ADDITIONAL_DATA_TYPE = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DATETIME: 'DATETIME',
  TOGGLE: 'TOGGLE',
  CHECKBOX: 'CHECKBOX',
  DROPDOWN: 'DROPDOWN',
  SINGLE_CHOICES: 'SINGLE_CHOICES',
  MULTI_CHOICES: 'MULTI_CHOICES',
};

export const CustomerFieldName = {
  firstName: 'FIRST_NAME',
  lastName: 'LAST_NAME',
  gender: 'GENDER',
  birthday: 'BIRTHDAY',
  referralCode: 'REFERRAL_CODE',
};

export const CustomerDetailCouponType = {
  Available: 'AVAILABLE',
  Unavailable: 'UNAVAILABLE',
  UsedOrExpired: 'USED_OR_EXPIRED',
};

export const TicketCampaignQuestionType = {
  customerProfileField: 'CUSTOMER_PROFILE_FIELD',
  customerAdditionalDataField: 'CUSTOMER_ADDITIONAL_DATA_FIELD',
  additionalQuestion: 'ADDITION_QUESTION',
};

export const DefaultCustomerFieldConfig = {
  FIRST_NAME: {
    title: 'personal_info_first_name',
    placeholder: 'personal_info_first_name',
    questionFormat: ADDITIONAL_DATA_TYPE.TEXT,
    userFieldName: 'firstName',
  },
  LAST_NAME: {
    title: 'personal_info_last_name',
    placeholder: 'personal_info_last_name',
    questionFormat: ADDITIONAL_DATA_TYPE.TEXT,
    userFieldName: 'lastName',
  },
  GENDER: {
    title: 'personal_info_gender',
    placeholder: 'personal_info_i_am',
    questionFormat: ADDITIONAL_DATA_TYPE.DROPDOWN,
    userFieldName: 'gender',
  },
  BIRTHDAY: {
    title: 'account_birth_month_year',
    placeholder: 'account_submit_birth_reminder',
    questionFormat: ADDITIONAL_DATA_TYPE.DATETIME,
    userFieldName: 'birthday',
  },
  REFERRAL_CODE: {
    title: 'personal_info_referral_code',
    placeholder: 'personal_info_referral_code',
    questionFormat: ADDITIONAL_DATA_TYPE.TEXT,
    userFieldName: 'refererCode',
  },
};

export const CouponTemplateType = {
  NORMAL: 'NORMAL',
  TICKET: 'TICKET',
};

export const CustomerSelectionBehavior = {
  NO_LIMIT: 'NO_LIMIT',
  SELECT_WHEN_ACQUIRE: 'SELECT_WHEN_ACQUIRE',
  SELECT_IN_WALLET: 'SELECT_IN_WALLET',
};

export const CouponSelectionType = {
  ONLINE_OFFLINE: 'ONLINE_OFFLINE',
  VIRTUAL_ONLINE_OFFLINE: 'VIRTUAL_ONLINE_OFFLINE',
  STORE: 'STORE',
  VIRTUAL_STORE: 'VIRTUAL_STORE',
};

export const EarningRuleGlobalLimitInfoType = {
  TRANSACTIONS: 'TRANSACTIONS',
  POINTS: 'POINTS',
  PROGRESSION_POINTS: 'PROGRESSION_POINTS',
  POINTS_AND_PROGRESSION_POINTS: 'POINTS_AND_PROGRESSION_POINTS',
  COUPONS: 'COUPONS',
  STAMPS: 'STAMPS',
};

export const EarningRuleGlobalLimitPeriod = {
  ALL_TIME: 'ALL_TIME',
  PER_DAY: 'PER_DAY',
  PER_WEEK: 'PER_WEEK',
  PER_MONTH: 'PER_MONTH',
  PER_YEAR: 'PER_YEAR',
};

export const EarningRuleGlobalLimitTarget = {
  REWARD_PROGRAM: 'REWARD_PROGRAM',
  PER_MEMBER: 'PER_MEMBER',
  PER_TRANSACTION: 'PER_TRANSACTION',
};

export const EarningRuleRewardLogicType = {
  TRANSACTION_VALUE: 'TRANSACTION_VALUE',
  ITEM_QUANTITY: 'ITEM_QUANTITY',
};

export const EarningRuleRewardAmountLogicType = {
  ONE_OFF: 'ONE_OFF',
  DYNAMIC: 'DYNAMIC',
};

export const CampaignType = {
  COUPON_CAMPAIGN: 'COUPON_CAMPAIGN',
  EARNING_CAMPAIGN: 'EARNING_CAMPAIGN',
  GENERAL_MESSAGE_CAMPAIGN: 'GENERAL_MESSAGE_CAMPAIGN',
  STAMP_CAMPAIGN: 'STAMP_CAMPAIGN',
  TICKET_CAMPAIGN: 'TICKET_CAMPAIGN',
};

export const EarningRuleType = {
  QR_CODE_SCANNING: 'QR_CODE_SCANNING',
  GPS_CHECK_IN: 'GPS_CHECK_IN',
  MEMBER_REFERRAL: 'MEMBER_REFERRAL',
  GENERAL_PURCHASE: 'GENERAL_PURCHASE',
  NEW_MEMBER: 'NEW_MEMBER',
  BIRTHDAY: 'BIRTHDAY',
  LEVEL_UPGRADE: 'LEVEL_UPGRADE',
};

export const MembershipCardBackgroundType = {
  SINGLE_COLOR: "SINGLE_COLOR",
  IMAGE: "IMAGE",
};

export const LevelCalculationSource = {
  SPENDING: "SPENDING",
  PROGRESSION_POINTS: "PROGRESSION_POINTS",
};

export const LevelUpgradeOptionType = {
  ACCUMULATED_TOTAL: "ACCUMULATED_TOTAL",
  ACCUMULATED_IN_X_DAYS: "ACCUMULATED_IN_X_DAYS",
  SPENDING_IN_ONE_PURCHASE: "SPENDING_IN_ONE_PURCHASE",
};

export const LevelRenewLogic = {
  RRTAIN_CURRENT_LEVEL: "RRTAIN_CURRENT_LEVEL",
  CHECK_RETAIN_REQUIREMENT: "CHECK_RETAIN_REQUIREMENT",
  SKIP_CHECKING_AND_FORCE_DOWNGRADE: "SKIP_CHECKING_AND_FORCE_DOWNGRADE",
};

export const LevelRetainType = {
  ACCUMULATED_SPENT: "ACCUMULATED_SPENT",
  TRANSACTIONS_TIMES: "TRANSACTIONS_TIMES",
  BOTH: "BOTH",
};

export const BottomTabRouteType = {
    BOTTOM_TAB_HOME: "HOME",
    BOTTOM_TAB_OFFER: 'OFFER',
    BOTTOM_TAB_PROFILE: 'PROFILE',
    BOTTOM_TAB_FAMILY_BOOKING: 'FAMILY_BOOKING',
    BOTTOM_TAB_RECORDS: 'RECORDS',
    BOTTOM_TAB_LOCATION: 'LOCATION',
};

export const NavType = {
  DROP_DOWN: "DROP_DOWN",
  LINK_TEXT: "LINK_TEXT", // default
}

export const WindowMessageType = {
  // sso resize window
  RESIZE: "RESIZE",

  // sso
  USERS_LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  CLOSE_SSO_IFRAME: "CLOSE_SSO_IFRAME",
  EVENT_REGISTER_SUCCESS: "EVENT_REGISTER_SUCCESS",
  EVENT_LOGIN_SUCCESS: "EVENT_LOGIN_SUCCESS",

  // shopify reward panel
  APPLY_CASH_CODE: "APPLY_CASH_CODE",

}